import type { SpeckleMaterial } from "@/types/Views/MappingWizard/SpeckleMaterial";

type SavedRow = Pick<SpeckleMaterial, "additionalParameters">;

// The classification lives in `additionalParameters`, and only the server knows which key it stored the
// pick under, so those come from the saved row. Everything else stays as the dialog had it.
export function resolveSavedMaterial<T extends { additionalParameters?: Record<string, string> | null }>(
  clone: T,
  savedRow: SavedRow | null | undefined
): T {
  if (!savedRow?.additionalParameters) return clone;
  return { ...clone, additionalParameters: { ...savedRow.additionalParameters } };
}
